export default {"src":"/_next/static/media/handbook-hero-bg.da91f04e.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};